let jsPdfPromise = null;

const getLoadedJsPdf = () => {
  if (typeof window === 'undefined') return null;
  return window.jspdf && window.jspdf.jsPDF ? window.jspdf.jsPDF : null;
};

export const loadJsPdf = async () => {
  const alreadyLoaded = getLoadedJsPdf();
  if (alreadyLoaded) return alreadyLoaded;

  if (!jsPdfPromise) {
    jsPdfPromise = import('jspdf')
      .then((module) => module.jsPDF || (module.default && module.default.jsPDF) || module.default)
      .then((JsPdf) => {
        if (typeof JsPdf !== 'function') {
          throw new Error('Gerador de PDF indisponível.');
        }
        return JsPdf;
      })
      .catch((error) => {
        jsPdfPromise = null;
        throw error;
      });
  }

  return jsPdfPromise;
};
